import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AnaestheticaPageRoutingModule } from './anaesthetica-routing.module';

import { AnaestheticaPage } from './anaesthetica.page';
import { Chooser } from '@awesome-cordova-plugins/chooser/ngx';
import { TextMaskModule } from 'angular2-text-mask';
import { IonicSelectableModule } from 'ionic-selectable';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    AnaestheticaPageRoutingModule,
    TextMaskModule,
    IonicSelectableModule

  ],
  declarations: [AnaestheticaPage],
  providers: [Chooser],
})
export class AnaestheticaPageModule { }
